import React , {useEffect , useState} from 'react'
import {motion} from 'framer-motion'
import './About.scss'
import { urlFor , client } from '../../client'
import { AppWrap , MotionWrap } from '../../wrapper'
// import { images } from '../../constants'

// const abouts = [
//   // {
//   //   title: 'Front-end Project',
//   //   description: ` Experience NIKE's modern and sleek website design, embodying the pinnacle of contemporary UI/UX standards for a seamless and stylish online journey.`,
//   //   imgUrl : images.about01
//   // },
//   // {
//   //   title: 'Web Design',
//   //   description: 'I bring digital ideas to life with expertise in full-stack web development.',
//   //   imgUrl : images.about02
//   // },
//   // {
//   //   title: 'MERN Stack',
//   //   description: 'I bring digital ideas to life with expertise in full-stack web development.',
//   //   imgUrl : images.about03
//   // }

// ]

const About = () => {

  const [abouts, setAbouts] = useState([]);
  useEffect(() => {
    const query = '*[_type == "abouts" ]';
    client.fetch(query).then((data)=>{
      setAbouts(data)
    })
   

  }, [])
  
  return (
    <>
    <h2 className='head-text'>
      I code experiences
      <br/>
      <span>
        Not just Websites
      </span>

    </h2>

    <div className='app__profiles'>
      {abouts.map((about, index)=>(
        <motion.div
        whileInView={{opacity:1}}
        whileHover={{scale: 1.1}}
        transition={{duration: 0.5, type: 'tween'}}
        className='app__profile-item'
        key={about.title.index}
        
        
        >

          <img src={urlFor(about.imgUrl)} alt={about.title} />
          <h2 className='bold-text' style={{marginTop:20}}>
            {about.title}
          </h2>
          <p className='p-text' style={{marginTop:10}}>
            {about.description}
          </p>
         
        </motion.div>
      ))}


    </div>
    </>
  )
}

export default AppWrap(MotionWrap(About , 'app__about') , 'about' , 'app__truecolor');